import React from 'react';
import {Link, useNavigate} from "react-router-dom";
import {OrdersHistoryFeature} from "./OrdersHistoryFeature";
import {Box, Button, Modal, Typography} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faTimesCircle} from "@fortawesome/free-solid-svg-icons";
import {observer} from "mobx-react";
import useFeature from "../../../useFeature";
import {useApplication} from "../../../ApplicationProvider";
import {CART_PATH} from "../../../routes";

const OrdersHistoryScreen = () => {
    const application = useApplication();
    const navigator = useNavigate();
    const feature = useFeature(() => new OrdersHistoryFeature(application, navigator))
    const handleVerMas = async () => {
        // TODO will orders be paginated?
    };

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    const updateOrderToRepeat = (order) => {
        feature.orderToRepeat = order
    }

    const editOrder = async (order) => {
        await feature.editOrder(order)
        navigator(CART_PATH)
    }

    const repeatOrder = () => {
        feature.repeatOrder()
    }

    return isFeatureReady(feature) && (
        <div className="container">
            <div className="row">
                <div className="col-xs-12">
                    <div className="text-center margintop30">
                        <div className="hidden-xs margintop60"></div>
                        <h3>Historial de pedidos</h3>
                    </div>

                    <div className="table-responsive margintop40 hidden-xs">
                        <table className="table table-pedidos">
                            <thead>
                            <tr>
                                <th>FECHA DE PEDIDO</th>
                                <th>ESTADO</th>
                                <th>ORDEN DE COMPRA</th>
                                <th>PUNTO DE VENTA</th>
                                <th>DETALLES</th>
                                <th>TOTAL</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody id="tbody">
                            {feature.orders.filter(order => !feature.isInRevisionOrRejected(order)).map((order, index) => (
                                <OrderItem key={index} order={order}
                                           handleRepeatOrder={(order) => updateOrderToRepeat(order)}
                                           editOrder={async (event) => await editOrder(order)}
                                           feature={feature}/>
                            ))}

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <ModalRepetirPedido order={feature.orderToRepeat} onClose={repeatOrder}/>
        </div>
    )
};


const OrderItem = ({order, handleRepeatOrder, editOrder, feature}) => {
    const isFacturado = order.state === 'FACTURADO';
    const canBeEdited = feature.orderIsFromMarketplace(order) && (order.state === 'ABIERTO' || order.state === 'CERRADO');
    const maxPaginas = 5;
    const pagina = 1;
    return (
        <>
            <tr>
                <td>
                    <span
                        className="material-symbols-outlined"
                        style={{
                            fontVariationSettings: "'FILL' 0, 'wght' 100, 'GRAD' 50, 'opsz' 20'",
                            color: '#5e5d5d',
                            fontSize: "1.2em",
                            marginRight: "5px",
                            position: "relative",
                            top: "4px"
                        }}
                    >
                        local_mall
                    </span>
                    <span className="fecha-pedido">
                        {order.deliveryDate}
                    </span>
                </td>
                <td className="hidden-sm">
                    <span className="label label-default font10">{order.state}</span>
                </td>
                <td>{order.customersOrderNumber}</td>
                <td>{order.deliverySite.deliverySiteName}</td>
                <td>
                    <div className="truncate-td">
                        {order.articles.map((article, index) => (
                            <div className="detail-item truncate" key={index}>
                                <span
                                    className="cantidad-cajas">{feature.articleAmountWithLabel(article)}</span>
                                <span style={{ fontFamily: 'ArcherSmbd', color: '#000000' }}> {article.name}</span>
                            </div>
                        ))}
                    </div>
                </td>
                <td>{feature.totalFor(order)}</td>
                <td>
                    <div style={{height: '8rem'}}>
                        <div className="flex" style={{height: '50%', alignItems: 'center'}}>
                            {/*{isFacturado && <button onClick={(order) => handleRepeatOrder(order)}*/}
                            {/*                        className="btn btn-primary btn-sm">Repetir</button>}*/}
                            {canBeEdited && <button onClick={(event) => editOrder(order)}
                                                    className="btn btn-primary btn-sm">Editar</button>}
                            <Link to={`/orders/detail/${feature.orderOrInvoiceNumber(order)}`}  className="btn btn-primary btn-sm btn-outlined">Ver</Link>
                        </div>
                    </div>
                </td>
            </tr>
            {maxPaginas < pagina && (
                <script type="text/javascript">
                    {`document.querySelector('[boton-ver-mas]').style.display = 'none';`}
                </script>
            )}
        </>
    );
};

const ModalRepetirPedido = ({order, onClose}) => {
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    return order && (
        <div>
            <Modal
                open={true}
                onClose={onClose}
                aria-labelledby="modal-repetir-pedido-title"
                aria-describedby="modal-repetir-pedido-description"
            >
                <Box sx={style}>
                    <Typography variant="h6" component="h2" id="modal-repetir-pedido-title">
                        <Button onClick={handleClose} style={{float: 'right'}}>
                            Cerrar <FontAwesomeIcon icon={faTimesCircle}/>
                        </Button>
                    </Typography>
                    <Typography variant="body1" component="div" id="modal-repetir-pedido-description">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-xs-12">
                                    <div className="text-center">
                                        <Typography variant="h4">Tiene artículos en el carrito ¿qué desea
                                            hacer?</Typography>
                                    </div>
                                </div>
                            </div>
                            <div className="row margintop40">
                                <div className="col-xs-12">
                                    <div className="modal-actions">
                                        <Button variant="contained" color="primary"
                                                href={`/Pedido/SumarPedidoActual/?pedidoId=${pedido.id}`}>
                                            Sumar al carrito
                                        </Button>
                                        <Button variant="outlined" color="secondary"
                                                href={`/Pedido/DescartarPedidoActual/?pedidoId=${pedido.id}`}
                                                style={{marginLeft: 15}}>
                                            Descartar el carrito
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Typography>
                </Box>
            </Modal>
        </div>
    );
};

export default observer(OrdersHistoryScreen);
